import {
  MerchantEmailConfigInputSchema,
  MerchantEmailConfigSchema,
} from "@redotech/redo-merchant-email-common/merchant-email-config";
import * as z from "zod";

export const upsertMerchantEmailConfig = {
  name: "upsertMerchantEmailConfig" as const,
  input: z.object({
    id: z.string().optional(),
    config: MerchantEmailConfigInputSchema,
  }),
  output: MerchantEmailConfigSchema,
};
